var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2473_5441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37222 0 0 5.37222 0 12C0 18.6278 5.37222 24 12 24C18.6278 24 24 18.6278 24 12C24 5.37222 18.6268 0 12 0ZM18.9524 18.269C18.9524 18.5391 18.7331 18.7584 18.463 18.7584C18.193 18.7584 17.9737 18.5391 17.9737 18.269V10.9248L12.001 5.23672L6.02827 10.9248V17.7787H9.35727V14.631C9.35727 14.361 9.5766 14.1417 9.84663 14.1417H14.1553C14.4253 14.1417 14.6447 14.361 14.6447 14.631V17.7787H16.453C16.723 17.7787 16.9423 17.998 16.9423 18.2681C16.9423 18.5381 16.723 18.7574 16.453 18.7574H14.1553C13.8853 18.7574 13.666 18.5381 13.666 18.2681V15.1204H10.337V18.2681C10.337 18.5381 10.1176 18.7574 9.8476 18.7574H5.53891C5.26889 18.7574 5.04955 18.5381 5.04955 18.2681V10.7142C5.04955 10.5807 5.10414 10.452 5.20162 10.3594L11.6647 4.20439C11.8538 4.02502 12.1511 4.02502 12.3402 4.20439L18.8032 10.3594C18.8998 10.452 18.9553 10.5797 18.9553 10.7142V18.2681L18.9524 18.269Z",
    fill: "#E70070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2473_5441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconHover);
export default __webpack_public_path__ + "static/media/home-icon-hover.0697138f098e236bc07fc0f3b59905c2.svg";
export { ForwardRef as ReactComponent };